/**
 * Declaring the redux reducers and default state
 * for Jobs Post Ad Features
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import { CONFIG_EVENTS } from '../../constants/events';
import PostAdFeatureHandler from '../../utils/JobsPostAd/featureHandler';
 
const defaultFeatureState = PostAdFeatureHandler.getAll();

const FeatureReducer = (state = defaultFeatureState, actions) => {
	switch (actions.type) {
		case CONFIG_EVENTS.CONFIG_UPDATED:
			state = Object.assign({}, state, PostAdFeatureHandler.getUpdatedFeatureConfig(actions.payload.store));
			break;
		default:
			return state;
	}

	return state;
};

export default FeatureReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/JobsPostAdReducer/featureReducer.js